import {
  ChangeDetectorRef,
  Component,
  ComponentRef,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { find } from 'lodash';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FlowService } from '@app/flow/shared';
import { environment } from '@env/environment';
import { ScrollToConfigOptions, ScrollToService } from '@nicky-lenaers/ngx-scroll-to';
import { isEmpty } from 'lodash';
import { LocalDataSource } from 'ng2-smart-table';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { SessionStorage } from 'ngx-webstorage';
import { Subject, Subscription } from 'rxjs';
import { Actividad } from '../models/actividad.model';
import { Annulation } from '../models/anulacion.model';
import { DocumentoAnexo, RadicadoCita } from '../models/documento.model';
import { TypeProcess } from '../models/proceso.model';
import { HistorialMicroproceso, Microproceso, Tarea } from '../models/tarea.model';
import { Etapas, Tramite } from '../models/tramite.model';
import { HelperFlowService } from '../services/helper-flow.service';
import { NotifierService } from '../services/notifier.service';
import { ToastrService } from 'ngx-toastr';
import { FlowTitle } from '../title';
import { Const } from '../util/constants';
import { DocumentsRecordsConfig } from './shared/documents-records.config.service';
import { DocumentsRecordsService } from './shared/documents-records.data.service';
import { RadicationYear } from '@app/forms/shared/radication-docs/shared/radication-docs-data.service';
import { ColumnsTableModalSelect } from '@app/shared';
import { DatePipe } from '@angular/common';
import { AuthenticationService } from '@app/core';

@Component({
  selector: 'iw-documents-records',
  templateUrl: './documents-records.component.html',
  styleUrls: ['./documents-records.component.scss'],
  providers: [DocumentsRecordsService]
})
// type Template = "primary";
export class DocumentsRecordsComponent implements OnInit, OnDestroy {
  messageAlertDynamic = '';
  // Datos de la tabla
  sourceData: LocalDataSource;
  // datos de tal tabla de anexos
  sourceAttachment: LocalDataSource;
  // Contiene la configuracion de la tabla
  settings = {};
  // Contiene la configuracion de la tabla de anexos
  settingsAttachment = {};
  //estructura de la tabla de documentos personalizada
  structure_table: any[] = [];
  //documentos del expediente
  documents_expedient: any[] = [];
  // documento seleccionado por el usuario
  rowSelect: any = {};
  // accion de descargar
  accion = '';
  // Contiene el radicado del expediente
  @Input() expediente: any = {};
  // Contiene el nombre del tramite
  @Input() tramite: string;
  columnsSelect: Array<ColumnsTableModalSelect> = [
    {
      key: 'radicado',
      label: 'Radicado'
    },
    {
      key: 'fecha',
      label: 'Fecha',
      type: 'date',
      view: false
    },
  ];
  // Instancia del trámite(default) seleccionado
  // La instancia puede ser un microproceso
  instance: Tramite | Microproceso;
  data: FlowTitle;
  // Muestra diferentes elementos
  show = {
    // Significado de la iconografía del flujo
    helperFlow: false,
    // Formulario de filtros de consulta
    filterForm: false,
  };
  isLoading = {
    listInstances: false,
    createInstance: false,
    showInstance: false,
    finishTask: false,
    startSecondary: false,
    cancelSecondary: false,
    associationTramite: false,
    alertDynamic: false,
  };
  // Contiene el tipo de proceso que se esta renderizando
  typeProcess: TypeProcess = 'process';
  // Contiene las etapas del tramite ( etapa actual y general)
  stage: Etapas;
  // Variable que determina si el formualrio está abierto
  openFormPreview: Boolean = false;
  // id secondary
  idSecondary = -1;
  // id secondary
  idTaskSecondary = -1;
  // Contiene el id de la primera actividad activada
  idActivityFirstActive = -1;
  // Contiene la información de anulación
  annulationInfo: Annulation = {};
  extensionsLabel = '';
  extensionsText = '';
  // Contiene los archivos subidos
  attachedDocuments: DocumentoAnexo[] = [];
  // Actividades de la instancia
  private _activities: Actividad[];
  historysMicroproces = {};
  historyMicroproce: HistorialMicroproceso[];
  idHistorySelect = 0;
  idsSelected: any[] = [];
  // Contiene temporalmente el año seleccionado para la consulta de radicados
  tmpAnioSelect = '';
  loadingSearchRadications = false;
  // define cuando estan cargando los años de radicados disponibles
  isLoadingRadicationYear = false;
  // Define si se habilita la opción de asociar un documento
  btnAssociateDocument = false;
  // lista de los años de los radicados disponibles
  radicationYear: RadicationYear[];
  // Define el formato en el que el usuario desea ver la informacion de las tareas
  isDesign = 'compact';
  formAssociateDocument: FormGroup = new FormGroup(
    {
      serie: new FormControl(null, [Validators.required]),
      subSerie: new FormControl(null, [Validators.required]),
      tipoDocumental: new FormControl(null, [Validators.required]),
      anio: new FormControl(null, [Validators.required]),
      radication: new FormControl(null, [Validators.required]),
      dateRadication: new FormControl(''),
    }
  );
  // Radicados consultados
  searchRadications: Array<RadicadoCita> = [];
  series: any[] = [];
  subSeries: any[] = [];
  tipoDocumental: any[] = [];
  // Plantilla que muestra el contenido del componente
  private _template: TemplateRef<any>;
  // Referencia de la modal
  private modalRef: BsModalRef;
  // Plantilla que muestra el contenido del componente
  private _templateF: TemplateRef<any>;
  // Suscripción a las notificaciones de los componentes hijos
  notifications: Subscription;
  tableDocuments: boolean = true;
  // Define cuando se esta generando o asociando el radicado
  loadingRadication = false;
  // almacena serie seleccionada
  selectSerie: any = null;
  // almacena la subserie seleccionada
  selectSubSerie: any = null;
  // almacena el tipo documental
  selectTypeDocument: any = null;
  // Define el formato en el que el usuario desea ver la informacion de las tareas  
  @SessionStorage() isDesignTaskPreview: string;
  // Controla si la memorai guardada
  private destroy: Subject<void> = new Subject<void>();
  @ViewChild('templatePreviewFlow') primaryTpl: TemplateRef<any>;
  @ViewChild('templatePreviewAttachments') TplAttachment: TemplateRef<any>;
  // Referencia al template de la modal de visualizacion de documento
  @ViewChild('templatePreviewDoc') private templatePreviewDoc: TemplateRef<any>;

  constructor(private drds: DocumentsRecordsService,
    private hfs: HelperFlowService,
    private fs: FlowService,
    private cdRef: ChangeDetectorRef,
    private modalService: BsModalService,
    private ns: NotifierService,
    private sts: ScrollToService,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private as: AuthenticationService
  ) {
  }

  ngOnInit() {
    //valida si la tabla es por consulta o fija
    this.loadDocuments();
    this.btnAssociateDocument = this.as.confirmPermission(
      Const.types_permissions.documentExp,
      Const.types_action_permissions.associatedDocument
    );

  }

  ngOnDestroy() {
    // Eliminar suscripción a las notificaciones\
    if (this.notifications) {
      this.notifications.unsubscribe();
    }
    this.destroy.next();
    this.destroy.complete();
  }

  actionTable(action: any) {
    this.accion = action;

  }

  loadDocuments() {
    if (environment.DocumentExpCustom) {
      this.drds.getDocumentExpedient(this.expediente.idExpediente).subscribe(async res => {
        if (res) {
          this.documents_expedient = await res.valores;
          this.documents_expedient.forEach(doc => {
            doc['value'] = true;
          });
          this.structure_table = await res.estructura;
          this.structure_table = this.structure_table.sort((a, b) => a.orden - b.orden);
          const configTable = new DocumentsRecordsConfig(this.structure_table);
          this.settings = configTable.settings;
          configTable.accion.subscribe((res: any) => {
            if (res.action && res.action == 'ver_flujo') {
              if (res.data[res.alias] && res.data[res.alias] != -1) {
                this.getInstance(res.data[res.alias]);
              }
            } else if (res.action && res.action == 'ver_anexos') {
              if (res.data[res.alias] && res.data[res.alias] != -1) {
                this.getAttached(res.data[res.alias]);
              }
            } else if (res.action && res.action == 'descarga_documento') {
              if (res.data) {
                if (res.data.anexo && res.data.anexo == true) {
                  this.download('anexo', res.data['id_documento']);
                } else {
                  this.download('documento', res.data['id_documento']);
                }
              }
            } else if (res.action && res.action == 'preview_documento') {
              if (res.data) {
                if (res.data.anexo && res.data.anexo == true) {
                  this.preview(res.data['id_documento'], true);
                } else {
                  this.preview(res.data['id_documento'], false);
                }
              }
            } else {
              this.actionTable(res.action);
            }
          });
          this.sourceData = new LocalDataSource(this.documents_expedient);
        }
      });
      // Escuchar todas las notificaciones de los elementos hijos del flujo
      this.notifications = this.ns.get().subscribe((n) => {
        // Si se ejecutó el evento click en una tarea
        if (n.source === 'task-preview' && n.eventTriggered === 'click') {
          this.clickedTask(n.data, n.action);
        } else if (n.source === 'title-preview' && n.eventTriggered === 'change' && n.action === 'changeDesign') {
          this.isDesign = this.isDesignTaskPreview ? this.isDesignTaskPreview : 'compact';
        }
      });
    } else {
      const configTable = new DocumentsRecordsConfig();
      this.settings = configTable.settings;
      configTable.accion.subscribe((res: any) => {
        this.actionTable(res.action);
      });
      this.drds.getDocumentExpedient(this.expediente.idExpediente).subscribe(async res => {
        if (res) {
          this.documents_expedient = await res.valores;
          this.documents_expedient.forEach(doc => {
            doc['value'] = true;
          });
          this.sourceData = new LocalDataSource(this.documents_expedient);
        }
      });
    }
  }

  async downloadDoc(data: any) {
    this.rowSelect = await data.data;
    if (this.accion == 'descargar' && this.rowSelect && (this.rowSelect.anexo == undefined || this.rowSelect.anexo == false)) {
      this.drds.dowloadFile(this.rowSelect.id_documento).subscribe((res: any) => {
        const a = document.createElement('a');
        a.target = '_blank';
        a.href = res.file.path;
        a.download = res.file.name;
        a.click();
        a.remove();
        this.accion = '';
      });
    } else if (this.accion == 'descargar' && this.rowSelect && this.rowSelect.anexo != undefined && this.rowSelect.anexo == true) {
      this.drds.getDownloadAttachedDocument(this.rowSelect.id_documento).subscribe(res => {
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.target = '_blank';
        a.href = res.path;
        a.download = res.name;
        a.click();
        window.URL.revokeObjectURL(res.path);
        a.remove();
        this.accion = '';
      });
    }
  }


  /**
   * Consulta una instancia de un trámite y genera su flujo.
   *
   * @param {number} idInstance
   * @memberof DocumentsRecordsComponent
   */
  getInstance(idInstance: number, clean: boolean = true) {
    this.isLoading.showInstance = true;
    this.fs
      .getInstance(idInstance)
      .finally(() => {
        this.isLoading.showInstance = false;
      })
      .subscribe(async (instance: Tramite) => {
        this.selectedInstance(instance, false, clean);
        // if(this.searchByProcess){
        //   await this.stcRefProcess.reload("tramite", instance.nombre);
        // }else{
        //   await this.stcRef.reload("tramite", instance.nombre);
        // }
      });
    this.template = 'primary';
    this.modalRef = this.modalService.show(
      this.primaryTpl, { class: 'modal-personalized-form', ignoreBackdropClick: true }
    );
    //Limpiar array de ids seleccionados
    // this.idsSelected = [];
  }

  /**
   * Consulta los anexos del documento.
   *
   * @param {number} idDocument
   * @memberof DocumentsRecordsComponent
   */
  getAttached(idDocument: number) {
    let configTable = new DocumentsRecordsConfig();
    this.settingsAttachment = configTable.settingsAttachment;
    configTable.accionAttachment.subscribe((data: any) => {
      this.accionTable(data.action, data.value.id);
    });
    this.drds.getAttachedDocument(idDocument).subscribe(async documents => {
      this.attachedDocuments = await documents;
      if (this.attachedDocuments.length) {
        this.attachedDocuments.map(document => {
          if (document.fecha_registro) {
            const date = new Date(document.fecha_registro);
            document.fecha_registro = date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
          }
          document['finish'] = true;
        });
      }
      this.sourceAttachment = new LocalDataSource(this.attachedDocuments);
      this.modalRef = this.modalService.show(
        this.TplAttachment, { class: 'modal-personalized-form', ignoreBackdropClick: true }
      );
    });
  }

  /**
   * Refresca el flujo actual
   *
   * @memberof DocumentsRecordsComponent
   */
  refreshFlow() {
    if (this.hfs.flowsHistory.length === 1) {
      this.isLoading.showInstance = true;
      this.fs
        .getInstance(this.hfs.flowsHistory[0])
        .finally(() => {
          this.isLoading.showInstance = false;
        })
        .subscribe((instance: Tramite) => {
          this.selectedInstance(instance, false, false, true);
        });
    } else {
      this.runMicroProcess(this.hfs.flowsHistory[this.hfs.flowsHistory.length - 1], false, false, true);
    }
  }

  set activities(v: Actividad[]) {
    this._activities = this.hfs.refineActivities(v, {
      filterByStatus: 'inactive',
    });
  }

  get activities(): Actividad[] {
    return this._activities;
  }

  /**
   * Define la plantilla que se debe mostrar.
   *
   * @memberof DocumentsRecordsComponent
   */
  set template(tpl: 'primary' | TemplateRef<any>) {
    let template: TemplateRef<any>;
    if (!(tpl instanceof TemplateRef)) {
      template = this.primaryTpl;

    } else {
      template = tpl;
    }
    this._template = template;
    this.cdRef.detectChanges();
  }

  get template() {
    return this._template;
  }

  set templateFPreview(tpl: TemplateRef<any>) {
    // let template: TemplateRef<any>;
    // template = tpl;
    this._templateF = tpl;
    this.cdRef.detectChanges();
  }

  get templateFPreview() {
    return this._templateF;
  }

  /**
   * Evento que se ejecuta al seleccionar una instancia
   * del trámite por default.
   * - Setea la instancia global usada para generar el flujo.
   * - Setea las actividades del flujo.
   *
   * @param {(Tramite | Microproceso)} instance
   * @param {boolean} [goBack=false]
   * @param {boolean} [clean=false]
   * @param {boolean} [changeCurrent=false]
   * @memberof DocumentsRecordsComponent
   */
  selectedInstance(
    instance: Tramite | Microproceso,
    goBack: boolean = false,
    clean: boolean = false,
    changeCurrent: boolean = false
  ) {
    this.hfs.updateFlowHistory(instance, goBack, clean, changeCurrent);
    this.instance = instance;
    if (instance && instance.actividades && instance.actividades.length) {
      for (const activity of instance.actividades) {
        if (activity.actividad_estado && activity.actividad_estado.nombre === Const.STATUS_ACTIVITY.pending) {
          this.idActivityFirstActive = activity.id;
          break;
        }
      }
    }
    this.activities = instance.actividades;
    this.data = this.hfs.getFlowTitle(instance);
    this.stage = null;
    this.fs.getStages(this.data.idTramite).subscribe((stage) => {
      if (Object.entries(stage.etapa_actual).length > 0) {
        this.stage = stage;
      }
    });
  }

  /**
   * Consulta un microproceso y crea su flujo.
   *
   * @private
   * @param {(Tarea | number)} task
   * @param {boolean} [goBack=false]
   * @param {boolean} [clean=false]
   * @param {boolean} [changeCurrent=false]
   * @param {boolean} [secondary=false]
   * @memberof DocumentsRecordsComponent
   */
  private async runMicroProcess(
    task: Tarea | number,
    goBack: boolean = false,
    clean: boolean = false,
    changeCurrent: boolean = false,
    secondary: boolean = false
  ) {
    this.isLoading.showInstance = true;
    let idTask = typeof task === 'number' ? task : task.id;
    if (typeof task === 'number') {
      idTask = task;
    } else if (task && task.historial_microproceso) {
      let ordenMax = 0;
      task.historial_microproceso.forEach((history) => {
        if (history.orden > ordenMax) {
          ordenMax = history.orden;
          idTask = history.id;
        }
      });
    } else {
      idTask = task.id;
    }
    if (typeof task === 'object') {
      if (!this.historysMicroproces[idTask]) {
        this.historysMicroproces[idTask] = task.id;
      }
      this.historyMicroproce = task.historial_microproceso;
    } else {
      if (this.historysMicroproces[idTask]) {
        this.historyMicroproce = await this.fs.getHistoryMicroproces(this.historysMicroproces[idTask]);
        if (this.historyMicroproce && this.historyMicroproce.length) {
          this.historyMicroproce.forEach((history) => {
            if (!this.historysMicroproces[history.id]) {
              this.historysMicroproces[history.id] = this.historysMicroproces[idTask];
            }
          });
        }
      }
    }
    if (this.historyMicroproce && this.historyMicroproce.length) {
      this.historyMicroproce.sort((a, b) => b.orden - a.orden);
    }
    this.idHistorySelect = idTask;
    this.fs
      .getMicroProcess(idTask)
      .finally(() => {
        this.isLoading.showInstance = false;
      })
      .subscribe((instance: Microproceso) => {
        if (secondary) {
          this.idSecondary = instance.id;
        }
        this.selectedInstance(instance, goBack, clean, changeCurrent);
      });
    this.template = 'primary';
  }

  cleanFlow() {
    this.instance = null;
  }

  /**
   * Se ejecuta cuando detecta una notificación con un
   * evento click de una tarea.
   * - Si la tarea es un microproceso genera su flujo.
   *
   * @private
   * @param {any} data
   * @param {string} action
   * @memberof DocumentsRecordsComponent
   */
  private clickedTask(data: any, action: string) {
    switch (action) {
      // Cuando se va abrir un formulario fuera de la modal
      case 'openFormOutModal':
        // this.backupDataSelectTramiteComponent();
        this.templateFPreview = data.template;
        this.openFormPreview = true;
        setTimeout(() => {
          this.sts.scrollTo({
            target: 'headerFlow',
          } as ScrollToConfigOptions);
        });
        break;
      // Mostrar cargar del flujo para accion de finalizar tarea
      case 'isLoadingFinishTask':
        this.isLoading.finishTask = true;
        this.openFormPreview = false;
        this.templateFPreview = null;
        break;
      case 'isLoadingAssociationTramite':
        this.isLoading.associationTramite = !this.isLoading.associationTramite;
        this.openFormPreview = false;
        this.templateFPreview = null;
        break;
      case 'closeLoadingFinishTask':
        this.isLoading.finishTask = false;
        break;
      // // Cuando se va a finalizar la tarea
      // case "finishTask":
      //   this.isLoading.finishTask = false;
      //   this.refreshInstance();
      //   break;
      // Cuando se va abrir un microproceso
      case 'runMicroProcess':
        if (!isEmpty(data)) {
          this.runMicroProcess(data.task);
        }
        break;
      // Cuando se va abrir una secundaria
      case 'runSecondary':
        this.typeProcess = 'secondary_process';
        if (!isEmpty(data)) {
          this.idTaskSecondary = data.task.id;
          this.runMicroProcess(data.task, false, false, false, true);
        }
        break;
      // Cuando se va a cerrar un formulario fuera de la modal
      case 'closeTaskForm':
        /*         this.template = 'primary'; */
        this.openFormPreview = false;
        this.templateFPreview = null;
        break;
      // Cuando se necesita actualizar la informacion del flujo
      case 'updateTask':
        const activityCurrent: Actividad = this.instance.actividades.find((element: Actividad) => {
          return element.id === data.meta.idActivity;
        });
        activityCurrent.tareas[data.meta.index] = data;
        break;
      // Cuando se necesita refrescar el flujo
      case 'refreshFlow':
        this.refreshFlow();
        break;
      // // Cuando se indica que se iniciaria un proceso secundario
      // case "startSecondary":
      //   this.startSecondary(data);
      //   break;
      // // Cuando se ejecuta el auto guardar en tareas
      // case "autoSave":
      //   if (data && data.length) {
      //     this.contextAutoSave = data;
      //     this.finishTaskAutoSave();
      //   } else {
      //     if (this.isLoading.alertDynamic) {
      //       this.messageAlertDynamic = "";
      //       this.isLoading.alertDynamic = false;
      //     }
      //     if (!this.contextAutoSave && !this.contextAutoSave.length) {
      //       this.refreshFlow();
      //     }
      //   }
      //   break;
      // Cuando se desea mostrar la alerta de cargando con un mensaje dinamico
      case 'alertLoadDynamic':
        if (data && typeof data === 'string') {
          this.messageAlertDynamic = data;
          this.isLoading.alertDynamic = true;
          this.openFormPreview = false;
          this.templateFPreview = null;
        } else {
          this.messageAlertDynamic = '';
          this.isLoading.alertDynamic = false;
        }
        break;
    }
  }

  /**
   * Retrocede un nivel en el flujo.
   *
   * @memberof DocumentsRecordsComponent
   */
  goBack() {
    if (this.idSecondary > 0) {
      if (this.idSecondary === this.instance.id) {
        this.typeProcess = 'process';
        this.idSecondary = -1;
        this.idTaskSecondary = -1;
      }
    }
    this.hfs.returnToPreviousFlow(
      // Generar el flujo de la instancia del trámite
      (idTramite) => {
        this.isLoading.showInstance = true;
        this.fs
          .getInstance(idTramite)
          .finally(() => {
            this.isLoading.showInstance = false;
          })
          .subscribe((instance: Tramite) => {
            this.selectedInstance(instance, true);
            this.typeProcess = 'process';
            this.idSecondary = -1;
            this.idTaskSecondary = -1;
          });
      },
      // Generar el flujo con el microproceso
      (idMicroProcess) => this.runMicroProcess(idMicroProcess, true)
    );
    //Limpiar array de ids seleccionados
    this.idsSelected = [];
  }

  /**
   * Controla las acciones en la tabla de anexos
   *
   * @param {string} action
   * @param {*} data
   * @memberof DocumentsRecordsComponent
   */
  accionTable(action: string, data: any) {
    switch (action) {
      case 'dowmload':
        this.drds.getDownloadAttachedDocument(data).subscribe(res => {
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.target = '_blank';
          a.href = res.path;
          a.download = res.name;
          a.click();
          window.URL.revokeObjectURL(res.path);
          a.remove();
          this.accion = '';
        });
        break;
    }
  }

  closeModalAttached() {
    this.modalRef.hide();
    this.attachedDocuments = [];
    this.settingsAttachment = {};
  }

  download(type_document: string, document_id: number) {
    if (type_document == 'documento') {
      this.drds.dowloadFile(document_id).subscribe((res: any) => {
        const a = document.createElement('a');
        a.target = '_blank';
        a.href = res.file.path;
        a.download = res.file.name;
        a.click();
        a.remove();
      }, err => {
      });
    } else if (type_document == 'anexo') {
      this.drds.getDownloadAttachedDocument(document_id).subscribe(res => {
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.target = '_blank';
        a.href = res.path;
        a.download = res.name;
        a.click();
        window.URL.revokeObjectURL(res.path);
        a.remove();
        this.accion = '';
      });
    }
  }

  preview(document_id: number, attachedDocument: boolean = false) {
    if (document_id && !attachedDocument) {
      this.drds.dowloadFile(document_id).subscribe((res: any) => {
        let type = res.file.path.split('.').pop();
        let document = {
          'tipo': type,
          'ruta': res.file.path,
          'rutaGoogle': 'https://docs.google.com/gview?url=' + res.file.path + '&embedded=true',
          'rutaMicrosoft': 'https://view.officeapps.live.com/op/view.aspx?src=' + res.file.path + '&wdOrigin=BROWSELINK'
        };
        document['ruta'] = res.file.path;
        this.modalRef = this.modalService.show(this.templatePreviewDoc, {
          class: 'modal-personalized',
          initialState: res.file
        });
        this.modalRef.content = document;
      }, err => {
      });
    } else if (document_id && attachedDocument) {
      this.drds.getDownloadAttachedDocument(document_id).subscribe((res: any) => {
        let type = res.path.split('.').pop();
        let document = {
          'tipo': type,
          'ruta': res.path,
          'rutaGoogle': 'https://docs.google.com/gview?url=' + res.path + '&embedded=true',
          'rutaMicrosoft': 'https://view.officeapps.live.com/op/view.aspx?src=' + res.path + '&wdOrigin=BROWSELINK'
        };
        if (type.toLowerCase() == 'pdf' || type.toLowerCase() == 'doc' || type.toLowerCase() == 'docx' || type.toLowerCase() == 'png' || type.toLowerCase() == 'jpg' || type.toLowerCase() == 'xls' || type.toLowerCase() == 'xlsx') {
          document['ruta'] = res.path;
          this.modalRef = this.modalService.show(this.templatePreviewDoc, {
            class: 'modal-personalized',
            initialState: res
          });
          this.modalRef.content = document;
        } else {
          this.toastr.warning('El documento no puede ser previsualizado dado que no tiene una extensión compatible', 'Fallo de previzualización');
        }
      }, err => {
      });

    }
  }

  closeModalAssociateDocument() {
    this.formAssociateDocument.reset();
    this.series = [];
    this.subSeries = [];
    this.tipoDocumental = [];
    this.radicationYear = null;
    this.sourceData = new LocalDataSource();
    this.tableDocuments = true;
    this.selectSerie = null;
    this.selectSubSerie = null;
    this.selectTypeDocument = null;
    this.searchRadications = [];
    this.tmpAnioSelect = '';
    this.loadDocuments();
  }

  openAssociateDocumentModal() {

    this.drds.getSeries().subscribe((res: any) => {
      this.series = res;
    });
    this.formAssociateDocument.controls['serie'].valueChanges.subscribe(((data: any) => {
      if ((data != null || data != undefined) && this.selectSerie != data) {
        this.selectSerie = data;
        this.drds.getSubSeriesBySerieId(data).subscribe((res: any) => {
          this.subSeries = res;
        });
      }
    }));
    this.formAssociateDocument.controls['subSerie'].valueChanges.subscribe(((data: any) => {
      if ((data != null || data != undefined) && this.selectSubSerie != data) {
        this.selectSubSerie = data
        this.drds.getTypeDocumentsBySubSerieId(data).subscribe((res: any) => {
          this.tipoDocumental = res;
        });
      }
    }));
    this.formAssociateDocument.controls['tipoDocumental'].valueChanges.subscribe(((data: any) => {
      if ((data != null || data != undefined) && this.selectTypeDocument != data) {
        this.selectTypeDocument = data;
        this.isLoadingRadicationYear = true;
        this.drds.getRadicationYears(data).subscribe(years => {
          this.radicationYear = years;
          this.isLoadingRadicationYear = false;
        });
      }
    }));
    this.formAssociateDocument.controls['radication'].valueChanges.subscribe(((data: any) => {
      if (data != null || data != undefined) {
        this.formAssociateDocument.controls['dateRadication'].setValue(this.datePipe.transform(data, 'yyyy'));
      }
    }));
    this.formAssociateDocument.controls['dateRadication'].disable();
    this.formAssociateDocument.controls['radication'].valueChanges.subscribe(((data: any) => {
      // Se asigna la fecha de radicado al campo correspondiente cuando este se selecciona
      if (this.searchRadications && this.searchRadications.length) {
        let rowSelect: any = {};
        rowSelect = find(this.searchRadications, { id: data });
        // const rowSelect = find(this.searchRadications, {iddocumento: data});
        if (rowSelect && rowSelect.fecha_original) {
          // this.formFechas.controls['dateRadication'].setValue(new Date(rowSelect.fecha + ' 00:00:00'));
          let date: Date;
          if (rowSelect.fecha_original instanceof Date) {
            date = rowSelect.fecha_original;
          } else {
            const radicate = String(rowSelect.fecha_original).split('T');
            const splitDate = radicate[0].split('-');
            date = new Date(
              Number(splitDate[2]),
              (Number(splitDate[1]) - 1),
              Number(splitDate[0]),
              rowSelect.fecha_original.getHours(),
              rowSelect.fecha_original.getMinutes(),
              rowSelect.fecha_original.getSeconds(),
              rowSelect.fecha_original.getMilliseconds(),
            );
          }
          this.formAssociateDocument.controls['dateRadication'].setValue(date);
        } else {
          this.formAssociateDocument.controls['dateRadication'].setValue(null);
        }
      } else {
        this.formAssociateDocument.controls['dateRadication'].setValue(null);
      }
    }));
    this.tableDocuments = false;
  }


  /**
   * Consulta los radicados de las fechas seleccionadas y el consecutivo ingresado
   *
   * @memberof DocumentsRecordsComponent
   */
  consultRadications() {
    if (this.formAssociateDocument.controls['anio'].value) {
      if (
        this.tmpAnioSelect !== this.formAssociateDocument.controls['anio'].value
      ) {
        this.formAssociateDocument.controls['radication'].reset();
        this.tmpAnioSelect = this.formAssociateDocument.controls['anio'].value;
        this.formAssociateDocument.disable();
        this.loadingSearchRadications = true;

        this.drds.getRadicationsCita(
          this.formAssociateDocument.controls['anio'].value,
          this.formAssociateDocument.controls['tipoDocumental'].value
        ).subscribe((dataDoc: any) => {
          this.searchRadications = dataDoc;
          this.searchRadications.forEach(sr => {
            sr.fecha_original = new Date(sr.fecha);
            sr.fecha = this.datePipe.transform(sr.fecha, 'yyyy-MM-dd');
          });
          this.formAssociateDocument.enable();
          this.loadingSearchRadications = false;
        }, () => {
          this.searchRadications = [];
          this.formAssociateDocument.enable();
          this.loadingSearchRadications = false;
        });
      }
    }
  }

  /**
   * Asocia un documento al expediente
   *
   * @memberof DocumentsRecordsComponent
   */

  associateDocument() {
    if (this.formAssociateDocument.valid && this.formAssociateDocument.controls['radication'].value) {
      this.loadingRadication = true;
      let docSelect: any;
      docSelect = find(this.searchRadications, { id: this.formAssociateDocument.controls['radication'].value });
      if (docSelect != undefined) {
        this.drds.associateDocument(this.expediente.idExpediente, docSelect.id).then(() => {
          this.loadingRadication = false;
          this.closeModalAssociateDocument();
        });
      }
    }

  }


}



// WEBPACK FOOTER //
// ./src/app/shared/documents-records/documents-records.component.ts